/* "Your bags have lost the plot" — ported verbatim from the PDP prototype
   (LostThePlot.astro, deployed at beamish-biscotti-5b9664.netlify.app,
   bundle CFzsyD8-). Geometry, items and the timeline/scroll config are the
   prototype's numbers, measured against the slb-plot-*.webp layers. Tune in
   the timeline block; ?plotDebug shows a live readout. */
(function () {
const g = {
    unitsPerCm: 33.45,
    holes: [
      [-118, -544],
      [-50, -546],
      [14, -540],
      [93, -539],
    ],
    layers: {
      openBack: { box: [-405, -737, 820, 755] },
      openFront: { box: [-405, -737, 820, 755] },
      zipPanel: { box: [-405, -737, 820, 755] },
      rim: { box: [-405, -737, 820, 755] },
      tabL: { box: [-274, -588, 81, 117] },
      tabR: { box: [140, -592, 87, 117] },
    },
    outline: [
      [-381, -255],
      [-377, -273],
      [-373, -479],
      [-369, -496],
      [-365, -509],
      [-361, -518],
      [-357, -525],
      [-353, -532],
      [-349, -540],
      [-345, -548],
      [-341, -554],
      [-337, -558],
      [-333, -562],
      [-329, -566],
      [-325, -569],
      [-321, -572],
      [-317, -576],
      [-313, -580],
      [-309, -583],
      [-305, -586],
      [-301, -588],
      [-297, -591],
      [-293, -593],
      [-289, -595],
      [-285, -598],
      [-281, -600],
      [-277, -602],
      [-273, -604],
      [-269, -606],
      [-265, -608],
      [-261, -609],
      [-257, -611],
      [-253, -613],
      [-249, -615],
      [-245, -616],
      [-241, -618],
      [-237, -619],
      [-233, -621],
      [-229, -623],
      [-225, -624],
      [-221, -626],
      [-217, -627],
      [-213, -629],
      [-209, -630],
      [-205, -632],
      [-201, -634],
      [-197, -636],
      [-193, -638],
      [-189, -640],
      [-185, -642],
      [-181, -643],
      [-177, -645],
      [-173, -647],
      [-169, -648],
      [-165, -649],
      [-161, -651],
      [-157, -652],
      [-153, -653],
      [-149, -654],
      [-145, -655],
      [-141, -656],
      [-137, -658],
      [-133, -659],
      [-129, -660],
      [-125, -662],
      [-121, -665],
      [-117, -668],
      [-113, -670],
      [-109, -673],
      [-105, -676],
      [-101, -678],
      [-97, -681],
      [-93, -683],
      [-89, -686],
      [-85, -688],
      [-81, -690],
      [-77, -693],
      [-73, -695],
      [-69, -697],
      [-65, -699],
      [-61, -701],
      [-57, -703],
      [-53, -705],
      [-49, -707],
      [-45, -710],
      [-41, -712],
      [-37, -714],
      [-33, -716],
      [-29, -718],
      [-25, -719],
      [-21, -721],
      [-17, -722],
      [-13, -722],
      [-9, -723],
      [-5, -723],
      [-1, -722],
      [3, -722],
      [7, -721],
      [11, -719],
      [15, -717],
      [19, -716],
      [23, -714],
      [27, -712],
      [31, -710],
      [35, -707],
      [39, -705],
      [43, -702],
      [47, -699],
      [51, -697],
      [55, -693],
      [59, -691],
      [63, -688],
      [67, -684],
      [71, -681],
      [75, -678],
      [79, -676],
      [83, -674],
      [87, -672],
      [91, -670],
      [95, -668],
      [99, -666],
      [103, -664],
      [107, -662],
      [111, -660],
      [115, -658],
      [119, -656],
      [123, -655],
      [127, -653],
      [131, -652],
      [135, -650],
      [139, -649],
      [143, -648],
      [147, -647],
      [151, -646],
      [155, -645],
      [159, -644],
      [163, -643],
      [167, -642],
      [171, -641],
      [175, -640],
      [179, -639],
      [183, -638],
      [187, -637],
      [191, -635],
      [195, -634],
      [199, -633],
      [203, -631],
      [207, -630],
      [211, -629],
      [215, -627],
      [219, -626],
      [223, -625],
      [227, -623],
      [231, -622],
      [235, -620],
      [239, -618],
      [243, -617],
      [247, -615],
      [251, -613],
      [255, -611],
      [259, -609],
      [263, -607],
      [267, -604],
      [271, -601],
      [275, -599],
      [279, -596],
      [283, -593],
      [287, -590],
      [291, -587],
      [295, -584],
      [299, -580],
      [303, -576],
      [307, -573],
      [311, -568],
      [315, -564],
      [319, -559],
      [323, -553],
      [327, -548],
      [331, -541],
      [335, -534],
      [339, -526],
      [343, -518],
      [347, -510],
      [351, -500],
      [355, -488],
      [359, -473],
      [363, -455],
      [367, -423],
      [371, -340],
      [375, -278],
      [379, -262],
      [383, -242],
    ],
    zip: {
      under: { box: [-295, -487, 640, 84] },
      over: { box: [-295, -487, 640, 84] },
      slider: { box: [-288, -454, 52, 39] },
      pull: { box: [-265, -425, 31, 60], pivot: [15, 4] },
      states: [
        { dx: 0, dy: 0 },
        { dx: 21, dy: -2.52 },
        { dx: 42, dy: -4.04 },
        { dx: 62, dy: -6.12 },
        { dx: 83, dy: -10.25 },
        { dx: 104, dy: -15.27 },
        { dx: 124, dy: -19.34 },
        { dx: 145, dy: -20.55 },
        { dx: 166, dy: -20.01 },
        { dx: 187, dy: -21.99 },
        { dx: 208, dy: -22.7 },
        { dx: 228, dy: -22.19 },
        { dx: 249, dy: -20.97 },
        { dx: 270, dy: -18.88 },
        { dx: 290, dy: -17.84 },
        { dx: 311, dy: -18.7 },
        { dx: 332, dy: -16.26 },
        { dx: 353, dy: -16.07 },
        { dx: 374, dy: -17.24 },
        { dx: 394, dy: -16.85 },
        { dx: 415, dy: -16.74 },
        { dx: 436, dy: -18.14 },
        { dx: 456, dy: -19.26 },
        { dx: 477, dy: -19.55 },
        { dx: 498, dy: -19.75 },
      ],
      gapTop: [
        [-282, -432.4],
        [-278, -433.2],
        [-274, -433.8],
        [-270, -434.6],
        [-266, -435.2],
        [-262, -435.9],
        [-258, -436.5],
        [-254, -437.2],
        [-250, -437.8],
        [-246, -438.5],
        [-242, -439.1],
        [-238, -439.7],
        [-234, -440.1],
        [-230, -440.5],
        [-226, -440.8],
        [-222, -441.1],
        [-218, -441.5],
        [-214, -442],
        [-210, -442.6],
        [-206, -443.3],
        [-202, -444.1],
        [-198, -444.9],
        [-194, -445.8],
        [-190, -446.8],
        [-186, -447.8],
        [-182, -448.8],
        [-178, -449.7],
        [-174, -450.7],
        [-170, -451.8],
        [-166, -452.9],
        [-162, -454.1],
        [-158, -455.3],
        [-154, -456.3],
        [-150, -457.3],
        [-146, -458.1],
        [-142, -458.8],
        [-138, -459.4],
        [-134, -460],
        [-130, -460.4],
        [-126, -460.7],
        [-122, -460.7],
        [-118, -460.5],
        [-114, -460.3],
        [-110, -460.1],
        [-106, -460],
        [-102, -460.1],
        [-98, -460.5],
        [-94, -460.9],
        [-90, -461.3],
        [-86, -461.7],
        [-82, -462.1],
        [-78, -462.4],
        [-74, -462.7],
        [-70, -462.9],
        [-66, -463.1],
        [-62, -463.2],
        [-58, -463.2],
        [-54, -463.2],
        [-50, -463.2],
        [-46, -463.1],
        [-42, -463],
        [-38, -462.9],
        [-34, -462.7],
        [-30, -462.5],
        [-26, -462.3],
        [-22, -462],
        [-18, -461.8],
        [-14, -461.5],
        [-10, -461.2],
        [-6, -460.9],
        [-2, -460.5],
        [2, -459.9],
        [6, -459.4],
        [10, -458.9],
        [14, -458.5],
        [18, -458.3],
        [22, -458.3],
        [26, -458.6],
        [30, -459],
        [34, -459.3],
        [38, -459.6],
        [42, -459.6],
        [46, -459.5],
        [50, -459.1],
        [54, -458.6],
        [58, -458.1],
        [62, -457.6],
        [66, -457.1],
        [70, -456.8],
        [74, -456.5],
        [78, -456.3],
        [82, -456.4],
        [86, -456.6],
        [90, -457],
        [94, -457.4],
        [98, -457.7],
        [102, -457.9],
        [106, -458],
        [110, -458],
        [114, -458],
        [118, -457.9],
        [122, -457.8],
        [126, -457.8],
        [130, -457.7],
        [134, -457.6],
        [138, -457.5],
        [142, -457.4],
        [146, -457.5],
        [150, -457.6],
        [154, -457.9],
        [158, -458.1],
        [162, -458.4],
        [166, -458.6],
        [170, -458.9],
        [174, -459.1],
        [178, -459.3],
        [182, -459.6],
        [186, -459.8],
        [190, -460],
        [194, -459.8],
        [198, -459.2],
        [202, -458.6],
        [206, -458],
        [210, -457.4],
        [214, -456.8],
        [218, -456.3],
      ],
      gapBottom: [
        [-282, -432.4],
        [-278, -432.5],
        [-274, -432.6],
        [-270, -432.6],
        [-266, -432.8],
        [-262, -432.9],
        [-258, -433.1],
        [-254, -433.2],
        [-250, -433.4],
        [-246, -433.6],
        [-242, -433.8],
        [-238, -433.9],
        [-234, -433.9],
        [-230, -433.9],
        [-226, -433.9],
        [-222, -433.8],
        [-218, -433.8],
        [-214, -433.9],
        [-210, -434.1],
        [-206, -434.3],
        [-202, -434.7],
        [-198, -435.1],
        [-194, -435.6],
        [-190, -436.1],
        [-186, -436.7],
        [-182, -437.3],
        [-178, -437.9],
        [-174, -438.5],
        [-170, -439.3],
        [-166, -440.1],
        [-162, -440.9],
        [-158, -441.8],
        [-154, -442.5],
        [-150, -443.2],
        [-146, -443.8],
        [-142, -444.2],
        [-138, -444.5],
        [-134, -444.8],
        [-130, -445],
        [-126, -445.1],
        [-122, -444.8],
        [-118, -444.4],
        [-114, -444],
        [-110, -443.6],
        [-106, -443.4],
        [-102, -443.4],
        [-98, -443.7],
        [-94, -444],
        [-90, -444.4],
        [-86, -444.8],
        [-82, -445.1],
        [-78, -445.4],
        [-74, -445.6],
        [-70, -445.8],
        [-66, -445.9],
        [-62, -446],
        [-58, -446],
        [-54, -445.9],
        [-50, -445.8],
        [-46, -445.7],
        [-42, -445.5],
        [-38, -445.3],
        [-34, -445.1],
        [-30, -444.9],
        [-26, -444.7],
        [-22, -444.4],
        [-18, -444.1],
        [-14, -443.9],
        [-10, -443.6],
        [-6, -443.3],
        [-2, -442.9],
        [2, -442.4],
        [6, -441.8],
        [10, -441.3],
        [14, -440.9],
        [18, -440.6],
        [22, -440.7],
        [26, -440.9],
        [30, -441.1],
        [34, -441.4],
        [38, -441.6],
        [42, -441.6],
        [46, -441.5],
        [50, -441.1],
        [54, -440.5],
        [58, -440],
        [62, -439.5],
        [66, -439.1],
        [70, -438.8],
        [74, -438.6],
        [78, -438.5],
        [82, -438.5],
        [86, -438.8],
        [90, -439.2],
        [94, -439.5],
        [98, -439.9],
        [102, -440],
        [106, -440.1],
        [110, -440],
        [114, -440],
        [118, -439.9],
        [122, -439.8],
        [126, -439.6],
        [130, -439.5],
        [134, -439.4],
        [138, -439.3],
        [142, -439.2],
        [146, -439.2],
        [150, -439.3],
        [154, -439.6],
        [158, -439.9],
        [162, -440.2],
        [166, -440.5],
        [170, -440.9],
        [174, -441.2],
        [178, -441.4],
        [182, -441.7],
        [186, -441.9],
        [190, -442.1],
        [194, -442.8],
        [198, -444.1],
        [202, -445.3],
        [206, -446.5],
        [210, -447.7],
        [214, -449],
        [218, -450.3],
      ],
    },
    items: {
      airpods: {
        src: "/assets/plot/items/airpods.webp",
        aspect: 1.3426356589147286,
      },
      bracelet: {
        src: "/assets/plot/items/bracelet.webp",
        aspect: 1.0034762456546928,
      },
      brush: {
        src: "/assets/plot/items/brush.webp",
        aspect: 0.3163972286374134,
      },
      deodorant: {
        src: "/assets/plot/items/deodorant.webp",
        aspect: 0.4122401847575058,
      },
      hairties: {
        src: "/assets/plot/items/hairties.webp",
        aspect: 1.1802197802197802,
      },
      mints: {
        src: "/assets/plot/items/mints.webp",
        aspect: 1.4127243066884176,
      },
      mouthguard: {
        src: "/assets/plot/items/mouthguard.webp",
        aspect: 1.6259398496240602,
      },
      rhode: {
        src: "/assets/plot/items/rhode.webp",
        aspect: 0.22055427251732102,
      },
      sunscreen: {
        src: "/assets/plot/items/sunscreen.webp",
        aspect: 0.41734104046242776,
      },
      vaseline: {
        src: "/assets/plot/items/vaseline.webp",
        aspect: 1.0128654970760234,
      },
      hoopA: {
        src: "/assets/plot/items/hoopA.webp",
        aspect: 0.9323,
        pivot: [0.5709, 0.0468],
        hang: [
          [0.1, 0.3376, 0.6058, 0.8985],
          [0.15, 0.2991, 0.5919, 0.8034],
          [0.2, 0.2254, 0.5246, 0.7917],
          [0.25, 0.2126, 0.5128, 0.7938],
          [0.3, 0.2019, 0.5021, 0.7949],
        ],
      },
      hoopB: {
        src: "/assets/plot/items/hoopB.webp",
        aspect: 0.9323,
        pivot: [0.5709, 0.0468],
        hang: [
          [0.1, 0.3376, 0.6058, 0.8985],
          [0.15, 0.2991, 0.5919, 0.8034],
          [0.2, 0.2254, 0.5246, 0.7917],
          [0.25, 0.2126, 0.5128, 0.7938],
          [0.3, 0.2019, 0.5021, 0.7949],
        ],
      },
      huggieA: {
        src: "/assets/plot/items/huggieA.webp",
        aspect: 1.0805,
        pivot: [0.5247, 0.0469],
        hang: [
          [0.1, 0.2402, 0.5167, 0.7745],
          [0.15, 0.1804, 0.5, 0.8176],
          [0.2, 0.1402, 0.4951, 0.8529],
          [0.25, 0.1127, 0.4951, 0.8804],
          [0.3, 0.0941, 0.4951, 0.898],
        ],
      },
      huggieB: {
        src: "/assets/plot/items/huggieB.webp",
        aspect: 1.0805,
        pivot: [0.5247, 0.0469],
        hang: [
          [0.1, 0.2402, 0.5167, 0.7745],
          [0.15, 0.1804, 0.5, 0.8176],
          [0.2, 0.1402, 0.4951, 0.8529],
          [0.25, 0.1127, 0.4951, 0.8804],
          [0.3, 0.0941, 0.4951, 0.898],
        ],
      },
    },
    closed: { box: [-388.81, -483.71, 777.62, 489.52] },
    back: { box: [-394.89, -486.55, 807.62, 496.46] },
    pocketFront: { box: [-394.89, -486.55, 807.62, 496.46] },
    phone: { seat: [-196.45, -350.19, 534.86, 259.41] },
    pocketEdgeX: 174.9,
    lip: [
      [-405, -350],
      [-375, -370],
      [-345, -369],
      [-315, -368],
      [-285, -376],
      [-255, -379],
      [-225, -379],
      [-195, -380],
      [-165, -381],
      [-135, -376],
      [-105, -365],
      [-75, -349],
      [-45, -334],
      [-15, -327],
      [15, -328],
      [45, -342],
      [75, -358],
      [105, -365],
      [135, -374],
      [165, -380],
      [195, -382],
      [225, -381],
      [255, -379],
      [285, -376],
      [315, -366],
      [345, -354],
      [375, -343],
      [405, -339],
    ],
    openTop: -723,
    arch: [
      [-335, -360],
      [-325, -390],
      [-315, -419],
      [-305, -439],
      [-295, -458],
      [-285, -477],
      [-275, -493],
      [-265, -508],
      [-255, -524],
      [-245, -539],
      [-235, -552],
      [-225, -565],
      [-215, -578],
      [-205, -587],
      [-195, -596],
      [-185, -606],
      [-175, -615],
      [-165, -623],
      [-155, -631],
      [-145, -640],
      [-135, -647],
      [-125, -653],
      [-115, -659],
      [-105, -666],
      [-95, -672],
      [-85, -678],
      [-75, -684],
      [-65, -689],
      [-55, -695],
      [-45, -700],
      [-35, -704],
      [-25, -708],
      [-15, -712],
      [-5, -714],
      [5, -712],
      [15, -706],
      [25, -699],
      [35, -693],
      [45, -687],
      [55, -680],
      [65, -674],
      [75, -667],
      [85, -659],
      [95, -651],
      [105, -643],
      [115, -634],
      [125, -626],
      [135, -617],
      [145, -608],
      [155, -599],
      [165, -589],
      [175, -580],
      [185, -570],
      [195, -560],
      [205, -550],
      [215, -540],
      [225, -530],
      [235, -517],
      [245, -505],
      [255, -493],
      [265, -478],
      [275, -463],
      [285, -447],
      [295, -429],
      [305, -411],
      [315, -389],
      [325, -367],
      [335, -340],
    ],
  },
  so = [
    {
      id: "airpods",
      label: "AirPods case",
      cm: 6.06,
      zone: "zip",
      fly: [0.0085, 0.0623],
      ring: { d: [-560, -820, -10], m: [-415, 950, -5] },
      rest: [-85, 0, 0],
    },
    {
      id: "vaseline",
      label: "Vaseline lip therapy mini",
      cm: 6.5,
      zone: "zip",
      fly: [0.0328, 0.0878],
      ring: { d: [-900, -820, 8], m: [-152, 950, 6] },
      rest: { d: [-145, 0, 0], m: [90, 0, 0] },
    },
    {
      id: "mints",
      label: "Altoids Smalls",
      cm: 6.7,
      zone: "zip",
      fly: [0.0374, 0.0934],
      ring: { d: [620, -720, -12], m: [122, 950, -4] },
      rest: { d: [88, 0, 0], m: [-141, 0, 0] },
    },
    {
      id: "mouthguard",
      label: "Mouthguard",
      cm: 6.9,
      zone: "zip",
      fly: [0.0634, 0.1161],
      ring: { d: [1e3, -820, -8], m: [402, 950, 5] },
      rest: [-40, 0, 0],
    },
    {
      id: "huggieA",
      label: "Pink huggie earring (left)",
      cm: 2.1,
      zone: "bar",
      hole: 0,
      fly: [0.0682, 0.1665],
      ring: { d: [-300, -930, -8], m: [352, 728, 0] },
    },
    {
      id: "huggieB",
      label: "Pink huggie earring (right)",
      cm: 2.1,
      zone: "bar",
      hole: 1,
      fly: [0.1419, 0.2402],
      ring: { d: [-230, -905, 10], m: [451, 728, 0] },
    },
    {
      id: "hoopA",
      label: "Gold hoop earring (left)",
      cm: 1.94,
      zone: "bar",
      hole: 2,
      fly: [0.2206, 0.3188],
      ring: { d: [140, -960, 6], m: [146, 728, 0] },
    },
    {
      id: "hoopB",
      label: "Gold hoop earring (right)",
      cm: 1.94,
      zone: "bar",
      hole: 3,
      fly: [0.2926, 0.3909],
      ring: { d: [225, -935, -10], m: [253, 728, 0] },
    },
    {
      id: "hairties",
      label: "Hair ties",
      cm: 7.5,
      zone: "loopR",
      pivot: [0.31, 0.03],
      fly: [0.2976, 0.4188],
      ring: { d: [-1040, -330, -6], m: [-450, 380, 0] },
      rest: [178, -548, 0],
    },
    {
      id: "bracelet",
      label: "Beaded bracelet",
      cm: 7,
      zone: "loopL",
      pivot: [0.56, 0.04],
      fly: [0.1469, 0.2681],
      ring: { d: [620, -380, 0], m: [-115, 372, 0] },
      rest: [-222, -545, 0],
    },
    {
      id: "rhode",
      label: "Rhode peptide lip tint",
      cm: 9.3,
      zone: "main",
      fly: [0.3696, 0.4745],
      ring: { d: [-760, -560, -30], m: [376, 203, -88] },
      rest: [-60, 0, -74],
    },
    {
      id: "deodorant",
      label: "Deodorant",
      cm: 11.7,
      zone: "main",
      fly: [0.4433, 0.5482],
      ring: { d: [-620, -270, 16], m: [-340, 203, 87] },
      rest: [150, 0, 76],
    },
    {
      id: "sunscreen",
      label: "Supergoop Unseen Sunscreen",
      cm: 9,
      zone: "main",
      fly: [0.4482, 0.5531],
      ring: { d: [1010, -430, -12], m: [36, 203, -93] },
      rest: [-120, 0, -82],
    },
    {
      id: "brush",
      label: "Wet Brush detangler",
      cm: 19.5,
      zone: "main",
      depth: 0.96,
      fly: [0.5203, 0.6284],
      ring: { d: [-780, 60, -96], m: [-228, 755, -88] },
      rest: [0, 0, -92],
    },
  ],
  ro = {
    scroll: {
      d: { start: 0.69, stuck: 1477 },
      // Theme change (was 1387): a shorter pinned run on phones so the
      // scene reads faster under a thumb.
      m: { start: 0.64, stuck: 1040 },
    },
    holdAt: 0.1665,
    smoothMs: 220,
    timeline: {
      settle: { zip: 0.017, bar: 0.0819, loop: 0.0622, main: 0.0688 },
      zipPouch: { open: [0, 0.0453], close: [0.1269, 0.1665] },
      packed: 0.7005,
      mainZip: [0.7071, 0.7824],
      questionOut: 0.3696,
      moveUp: [0.3696, 0.8954],
      flip: [0.7857, 0.8889],
      answerIn: 0.8872,
      phoneWalk: [0.7627, 0.8889],
      phoneTuck: [0.8954, 0.9577],
      unpack: {
        zip: 0.0113,
        bar: 0.1419,
        loop: 0.3205,
        main: 0.5105,
        cascade: 0.0049,
        zipPouch: { open: [0, 0.0453], close: [0.1129, 0.1411] },
      },
    },
    phone: { ring: { d: [720, -30, 8], m: [279, 469, 0] } },
    // Theme change (was m: 0.8). Phones lay the mess out as a flat-lay grid
    // under the bag, so the items can run a little larger and fill the stage
    // instead of floating in it. Row order follows the clean-up order: the
    // zip-pouch four (airpods, lip balm, mints, mouthguard) sit in the bottom
    // row because they are already zipped away by the time the section pins
    // (zipPouch closes at holdAt), so their row empties into the bottom
    // margin instead of leaving a hole under the bag. See the m rings.
    messScale: { d: 1, m: 0.9 },
    assist: {
      on: !0,
      from: 0.1665,
      to: 0.9577,
      ms: 4830,
      lead: 120,
      wait: 700,
    },
    items: so,
  },
  ue = g.items,
  Be = g.zip.states.length,
  b = {
    ground: 1,
    behind: 2,
    openBack: 10,
    zipUnder: 11,
    zipOver: 13,
    zipPanel: 14,
    pull: 17,
    slider: 18,
    earring: 19,
    loopItem: 20,
    loopFly: 21,
    tab: 22,
    rim: 22,
    main: 23,
    plate: 40,
    pocket: 45,
    pocketFront: 50,
    air: 70,
    fly: 71,
    pouchIn: 24,
  },
  q = (a, h = 0, _ = 1) => Math.min(_, Math.max(h, a)),
  M = (a, h, _) => a + (h - a) * _,
  nt = (a, [h, _]) => q((a - h) / (_ - h)),
  It = (a) => (a < 0.5 ? 4 * a * a * a : 1 - (-2 * a + 2) ** 3 / 2),
  pt = (a) => 1 - (1 - a) ** 3,
  _t = (a) => a * a * a,
  qt = (a, h, _ = 1) =>
    a <= 0 || a >= 1 ? 0 : h * (1 - a) ** 2 * Math.sin(2 * Math.PI * _ * a),
  io = (a, h = 0.12, _ = 0.3) => {
    if (a <= 0) return 0;
    if (a >= 1) return 1;
    const S = 1 / (1 - h / 2 - _ / 2);
    return a < h
      ? (S * a * a) / (2 * h)
      : a <= 1 - _
        ? S * (h / 2 + a - h)
        : 1 - (S * (1 - a) * (1 - a)) / (2 * _);
  },
  st = (a) => (a <= 0 || a >= 1 ? 0 : Math.sin(Math.PI * a)),
  Oe = (a) => {
    if (a < 0.15) return -0.035 * st(a / 0.15 / 2 + 0.5) * (a / 0.15);
    const h = (a - 0.15) / 0.85;
    return 0.5 * h + 0.25 * (1 - Math.cos(Math.PI * h));
  };
function ao(a, h) {
  const _ = a.querySelector("[data-plot-stage]"),
    S = (t) => _.querySelector(`[data-l="${t}"]`),
    d = {
      ground: S("ground"),
      openBack: S("openBack"),
      openFront: S("openFront"),
      zipPanel: S("zipPanel"),
      tabL: S("tabL"),
      tabR: S("tabR"),
      rim: S("rim"),
      zipUnder: S("zipUnder"),
      zipOver: S("zipOver"),
      zipUnderImg: S("zipUnderImg"),
      zipOverImg: S("zipOverImg"),
      slider: S("slider"),
      pull: S("pull"),
      closed: S("closed"),
      back: S("back"),
      pocketFront: S("pocketFront"),
      phone: S("phone"),
    },
    U = h.items.map((t) => ({ it: t, node: S(t.id) })),
    Ht = a.querySelector("[data-head-a]"),
    gt = a.querySelector("[data-head-b]"),
    Zt = gt.parentElement,
    at = a.querySelector("[data-plot-move]"),
    O = h.timeline,
    Vt = [],
    Q = U.map(({ it: t }) => {
      const e = t.cm * g.unitsPerCm,
        o = t.aspect ?? ue[t.id].aspect;
      return o >= 1 ? { w: e, h: e / o } : { w: e * o, h: e };
    }),
    St = U.map(({ it: t }) => t.pivot ?? ue[t.id].pivot ?? [0.5, 0.5]);
  let Ut = [];
  // How far the stage has zoomed by the final frame (the grow in Pt).
  const growTo = 1.34;
  const Jt = 0.2,
    qe = 0.72,
    me = 0.14,
    He = 1.5,
    Ue = (t) =>
      t === "zip"
        ? O.settle.zip
        : t === "bar"
          ? O.settle.bar
          : t === "main"
            ? O.settle.main
            : O.settle.loop,
    xe = (t) => (t === "zip" || t === "bar" || t === "main" ? t : "loop"),
    Ye = U.map(({ it: t }) => {
      const e = xe(t.zone),
        o = U.filter(
          ({ it: s }) => xe(s.zone) === e && s.fly[0] < t.fly[0],
        ).length,
        n = O.unpack[e] + o * O.unpack.cascade;
      return [n, n + t.fly[1] - t.fly[0]];
    }),
    We = 60;
  let dt = 1;
  const Qt = (t, e) => [M(t[0], e[0], dt), M(t[1], e[1], dt)],
    ye = (t) => Qt(Ye[t], U[t].it.fly),
    G = g.layers,
    te = (t) => [t[0] + t[2] / 2, t[1] + t[3] / 2],
    zt = (t, e) => {
      if (e <= t[0][0]) return t[0][1];
      for (let o = 1; o < t.length; o++)
        if (e <= t[o][0])
          return M(
            t[o - 1][1],
            t[o][1],
            (e - t[o - 1][0]) / (t[o][0] - t[o - 1][0]),
          );
      return t[t.length - 1][1];
    },
    ee = (t) => zt(g.lip, t),
    fe = (t) =>
      t < g.arch[0][0] || t > g.arch[g.arch.length - 1][0]
        ? 1 / 0
        : zt(g.arch, t),
    De = (t) => zt(g.zip.gapTop, t),
    oe = (t) => zt(g.zip.gapBottom, t),
    Yt = (t, e, o, n) => {
      const s = (o * Math.PI) / 180,
        c = Math.abs(Math.cos(s)),
        l = Math.abs(Math.sin(s));
      return { x: ((t * c + e * l) * n) / 2, y: ((t * l + e * c) * n) / 2 };
    };
  let V = 1,
    Tt = 0,
    xt = 0,
    ht = 0,
    wt = 0,
    K = "d",
    ne = 0,
    hop = 0;
  function Ce() {
    if (kt >= 0) {
      // Static (reduced motion, very short screens): no flights and no
      // flat-lay, just the packed bag, centered in a stage Ke sizes to it.
      V = (0.86 * wt) / 763;
      Tt = ht / 2;
      xt = wt / 2 + 341.5 * V;
      return;
    }
    if (K === "d") {
      // Theme change (cap was a flat 0.72): past 1920 wide the cap eases up
      // to 0.88, or the scene sits small in a field of white on a 2560
      // screen. The open-bag layers are drawn 1:1 at 1, so this stays sharp.
      V = Math.min(
        (0.62 * wt) / 737,
        (0.4 * ht) / 766,
        q(0.72 + (ht - 1920) * 0.00025, 0.72, 0.88),
      );
      Tt = ht / 2;
      xt = 0.88 * wt;
      return;
    }
    // Theme change (was 0.68 * wt): on phones the bag sits in the upper
    // half of the stage and the whole mess is laid out beneath it (see the
    // m rings), instead of scattered around all four sides. The open lid to
    // the bottom of the flat-lay still on show at the pin is the
    // composition; the height left over splits 2:3 above and below it, so
    // tall phones don't end in a band of white. The room above also has to
    // take the highest hop over the lid (hop, set in Ke), or the stage edge
    // under the headline slices the top off it.
    const lay = mLayBottom() - g.openTop,
      foot = Math.max(16, 0.035 * wt);
    V = Math.min(
      (0.66 * ht) / 766,
      (0.4 * wt) / 737,
      (wt - foot - 6) / (lay + hop),
    );
    Tt = ht / 2;
    const left = wt - lay * V;
    xt = -g.openTop * V + q(hop * V + 6, 0.4 * left, left - foot);
  }
  // Units the flights rise above the open lid's top, outside the zip pouch
  // (that one packs before the pin, below the fold).
  function hopAbove() {
    let top = 0;
    U.forEach(({ it: t }, e) => {
      if (t.zone === "zip") return;
      for (let i = 0; i <= 40; i++) top = Math.min(top, vt(e, re(e, i / 40)).y0);
    });
    return Math.max(0, g.openTop - top);
  }
  function mLayBottom() {
    let y = 0;
    U.forEach(({ it: t }, e) => {
      if (t.zone === "zip") return;
      const [, o, n] = t.ring.m;
      y = Math.max(y, o + Yt(Q[e].w, Q[e].h, n, h.messScale.m).y);
    });
    return y;
  }
  function se(t, e, o) {
    const n = t;
    ((n._w = e * V),
      (n._h = o * V),
      (t.style.width = `${n._w}px`),
      (t.style.height = `${n._h}px`));
  }
  function ct(t, e, o, n = 0, s = 1, c = s, l, y = 0.5, r = 0.5) {
    const u = t,
      L = `${y * 100}% ${r * 100}%`;
    (u._o !== L && ((t.style.transformOrigin = L), (u._o = L)),
      (t.style.transform = `translate3d(${(Tt + e * V - y * u._w).toFixed(2)}px, ${(xt + o * V - r * u._h).toFixed(2)}px, 0) rotate(${n.toFixed(3)}deg) scale(${s.toFixed(4)}, ${c.toFixed(4)})`),
      l !== void 0 && (t.style.zIndex = String(l)));
  }
  const ut = (t, e) => {
    const o = e ? "visible" : "hidden";
    t.style.visibility !== o && (t.style.visibility = o);
  };
  function Xe() {
    const t = (e, o) => se(e, o[2], o[3]);
    (t(d.openBack, G.openBack.box),
      t(d.openFront, G.openFront.box),
      t(d.zipPanel, G.zipPanel.box),
      t(d.tabL, G.tabL.box),
      t(d.tabR, G.tabR.box),
      t(d.rim, G.rim.box),
      t(d.zipUnder, g.zip.under.box),
      t(d.zipOver, g.zip.over.box),
      t(d.slider, g.zip.slider.box),
      t(d.pull, g.zip.pull.box),
      t(d.closed, g.closed.box),
      t(d.back, g.back.box),
      t(d.pocketFront, g.pocketFront.box),
      t(d.phone, g.phone.seat),
      se(d.ground, 900, 90),
      U.forEach(({ node: e }, o) => se(e, Q[o].w, Q[o].h)),
      _.style.setProperty("--sh", `${Math.max(2, 10 * V).toFixed(1)}px`));
  }
  let Mt = [],
    tt = { x: 0, y: 0, r: 0, s: 1 };
  function je() {
    const t = Math.max(16, 0.04 * ht),
      e = {
        x0: (-Tt + t) / V,
        x1: (ht - Tt - t) / V,
        y0: (-xt + 8) / V,
        y1: (wt - xt - 12) / V,
      },
      o = (u, L, R, H, T, x) => {
        const v = Yt(R, H, T, x);
        return [q(u, e.x0 + v.x, e.x1 - v.x), q(L, e.y0 + v.y, e.y1 - v.y)];
      };
    Mt = U.map(({ it: u }, L) => {
      const [R, H, T] = u.ring[K],
        x = h.messScale[K],
        [v, f] = o(R, H, Q[L].w, Q[L].h, T, x);
      return { x: v, y: f, r: T, s: x };
    });
    const [n, s, c] = h.phone.ring[K],
      l = h.messScale[K],
      [y, r] = o(n, s, g.phone.seat[2], g.phone.seat[3], c, l);
    tt = { x: y, y: r, r: c, s: l };
    // Theme addition: items laid out under the bag swing wide around it on
    // the way in (see re). On a phone the full swing carries the long ones
    // off the edge, so take the widest swing that stays in the frame.
    const B = (Tt - Math.max(8, 0.02 * ht)) / V;
    sw = U.map(({ it: u }, L) => {
      const m = Mt[L],
        k = Wt(L, m),
        sg = Math.sign(m.x || k.x || 1),
        over = (cx) => {
          let worst = -1 / 0;
          for (let i = 0; i <= 20; i++) {
            const e = i / 20,
              j = 1 - e,
              x = j * j * m.x + 2 * j * e * cx + e * e * k.x,
              v = Yt(Q[L].w, Q[L].h, M(m.r, k.r, e), M(m.s, k.s, e)).x;
            worst = Math.max(worst, Math.abs(x) + v - B);
          }
          return worst;
        };
      let best = 520,
        bo = 1 / 0;
      for (let c = 520; c >= 0; c -= 20) {
        const ov = over(sg * c);
        if (ov <= 0) return c;
        ov < bo && ((bo = ov), (best = c));
      }
      return best;
    });
  }
  let sw = [];
  function Ge(t) {
    const { w: e, h: o } = Q[t],
      [n, , s] = Ut[t],
      c = Yt(e, o, s, 1);
    let l = -1 / 0;
    for (let y = n - c.x; y <= n + c.x; y += 8) l = Math.max(l, ee(y));
    return Math.min(l + c.y + 12, -c.y - 10);
  }
  let be = [];
  // What the site header still covers once the scene is pinned. Only a fixed
  // header, or a sticky one whose containing block runs past this section,
  // is on screen by then; this theme's header scrolls away with its group.
  function hdrCover() {
    const t = document.querySelector(h.headerSelector ?? ".site-header");
    for (let n = t; n && n !== document.body; n = n.parentElement) {
      const cs = getComputedStyle(n);
      if (
        cs.position === "fixed" ||
        (cs.position === "sticky" && n.parentElement.contains(a))
      )
        return n.offsetHeight + (parseFloat(cs.top) || 0);
    }
    return 0;
  }
  // The static stage: tall enough for the packed bag (763 units, lid to
  // shadow) at 86% of it, the bag as wide as the screen allows, and the
  // section no taller than a screen (or 820px).
  function staticStage() {
    const room =
        Math.min(document.documentElement.clientHeight, 820) -
        (at ? at.offsetTop : 0) -
        _.offsetTop,
      v = Math.min((0.66 * ht) / 820, 0.72, (0.86 * Math.max(200, room)) / 763);
    return ((763 * v) / 0.86).toFixed(1);
  }
  function Ke() {
    (a.style.setProperty("--plot-hdr", `${hdrCover()}px`),
      (ht = _.clientWidth),
      // Theme change: portrait screens (tablets held upright) take the phone
      // composition. The desktop one is built for landscape; on a tall stage
      // it strands the scene at the bottom under a band of white.
      (K =
        ht < 700 || document.documentElement.clientHeight > 1.1 * ht
          ? "m"
          : "d"),
      a.classList.toggle("is-m", K === "m"),
      kt >= 0 &&
        a.style.setProperty("--plot-static-stage", `${staticStage()}px`),
      (wt = _.clientHeight),
      (Ut = U.map(({ it: n }) => {
        const s = n.rest ?? [0, 0, 0];
        return Array.isArray(s) ? s : s[K];
      })));
    const lay = () => {
      (Ce(), Xe(), je(), (be = U.map((n, s) => Ge(s))), Ne(), Je());
    };
    ((hop = 0), lay());
    if (K === "m" && kt < 0) ((hop = hopAbove()), hop > 0 && lay());
    const e = document.documentElement.clientHeight,
      { stuck: o } = h.scroll[K];
    if ((a.style.setProperty("--plot-hold", `${o}px`), at)) {
      const n = _.offsetTop + xt + g.openTop * V,
        s = _.offsetTop + xt,
        c = n - (Ht.offsetTop + Ht.offsetHeight),
        l = s + c;
      (a.style.setProperty(
        "--plot-b-top",
        `${(l - at.clientHeight).toFixed(1)}px`,
      ),
        // Theme change (was: answer bottom at 92% of the viewport): the rise
        // centers the final frame, the grown bag over the answer line, in
        // the viewport.
        (ne = Math.max(
          0,
          at.offsetTop +
            (_.offsetTop +
              0.44 * wt +
              (xt + g.back.box[1] * V - 0.44 * wt) * growTo +
              l +
              gt.offsetHeight) /
              2 -
            e / 2,
        )));
    }
    Pt(N);
  }
  function Wt(t, e) {
    const { it: o } = U[t],
      { h: n } = Q[t],
      [s, c, l] = Ut[t];
    switch (o.zone) {
      case "zip":
        return { x: s, y: De(s) - 6 - n / 2, r: l, s: 1, z: b.pouchIn };
      case "bar": {
        const [y, r] = g.holes[o.hole];
        return { x: y, y: r + St[t][1] * n + 2, r: 0, s: 1, z: b.air };
      }
      case "loopL":
        return { x: s + 40, y: c - 45, r: -4, s: 1, z: b.loopItem };
      case "loopR":
        return { x: s - 40, y: c - 45, r: 4, s: 1, z: b.loopItem };
      default:
        return {
          x: s + Math.sign(e.x || 1) * 240,
          y: -700,
          r: M(e.r, l, 0.5),
          s: 1.02,
          z: b.air,
        };
    }
  }
  function vt(t, e) {
    const { w: o, h: n } = Q[t],
      [s, c] = St[t],
      l = e.s,
      y = e.sy ?? 1,
      r = (e.r * Math.PI) / 180,
      u = (0.5 - s) * o * l,
      L = (0.5 - c) * n * l * y,
      R = e.x + u * Math.cos(r) - L * Math.sin(r),
      H = e.y + u * Math.sin(r) + L * Math.cos(r),
      T = Yt(o, n * y, e.r, l);
    return { x0: R - T.x, y0: H - T.y, x1: R + T.x, y1: H + T.y };
  }
  const ge = (t) => ({ x0: t[0], y0: t[1], x1: t[0] + t[2], y1: t[1] + t[3] }),
    $t = (t, e, o = 6) =>
      t.x0 < e.x1 + o && t.x1 > e.x0 - o && t.y0 < e.y1 + o && t.y1 > e.y0 - o;
  let Dt = [],
    ze = [];
  const Ct = 26;
  function Ne() {
    const t = G.openFront.box,
      e = t[2] / 2,
      o = t[0] + e,
      n = G.tabL.box,
      s = G.tabR.box,
      c = (n[0] + n[2] + s[0]) / 2,
      l = g.outline,
      y = (x) => (x < l[0][0] || x > l[l.length - 1][0] ? 1 / 0 : zt(l, x)),
      r = (x, v = Ct) => {
        if (x.y0 - v > 8) return !1;
        for (let f = x.x0 - v; f <= x.x1 + v; f += 4)
          if (y(f) < x.y1 + v) return !0;
        return !1;
      },
      u = (x, v, f, A, Y = 24) =>
        Array.from({ length: Y }, ($, et) => {
          const E = et / Y,
            i = 1 - E;
          return [0, 1].map(
            (w) =>
              i * i * i * x[w] +
              3 * i * i * E * v[w] +
              3 * i * E * E * f[w] +
              E * E * E * A[w],
          );
        });
    Dt = U.map(({ it: x }, v) => {
      if (x.zone !== "loopL" && x.zone !== "loopR") return null;
      const f = Mt[v],
        A = Wt(v, f),
        Y = x.zone === "loopR" ? 1 : -1,
        { w: $, h: et } = Q[v],
        [E, i] = St[v],
        w = f.y > A.y + 200 && Math.abs(f.x - o) < e + 0.3 * $,
        p = c - (0.5 - E) * $;
      let B = 1 / 0,
        m = -1 / 0;
      for (let P = p - E * $; P <= p + (1 - E) * $; P += 8)
        ((B = Math.min(B, ee(P))), (m = Math.max(m, fe(P))));
      const z = m + i * et + 8,
        k = B - (1 - i) * et - 8,
        W = z <= k ? q(A.y, z, k) : Math.min(A.y, k);
      let F = [];
      if (w) {
        const P = f.x,
          C = P + Math.sign(o - P) * 60,
          X = (C + p) / 2,
          ot = vt(v, { x: C, y: 0, r: A.r, s: 1 });
        let j = 1 / 0;
        for (let J = ot.x0 - 8; J <= ot.x1 + 8; J += 4)
          j = Math.min(j, y(J) - 10 - ot.y1);
        F = [
          ...u([P, f.y], [P, M(f.y, j, 0.6)], [P, j], [C, j]),
          ...u([C, j], [X, j], [X, W], [p, W]),
          ...u(
            [p, W],
            [M(p, A.x, 1 / 3), W],
            [M(p, A.x, 2 / 3), A.y],
            [A.x, A.y],
            12,
          ),
        ];
      } else {
        const P = [
            [f.x, f.y],
            [o - Y * (e - 50), W],
            [p, W],
            [A.x, A.y],
          ],
          C = (X) => P[Math.max(0, Math.min(P.length - 1, X))];
        for (let X = 0; X < P.length - 1; X++) {
          const [ot, j, J, bt] = [C(X - 1), C(X), C(X + 1), C(X + 2)];
          for (let Rt = 0; Rt < 24; Rt++) {
            const mt = Rt / 24;
            F.push(
              [0, 1].map(
                (Z) =>
                  0.5 *
                  (2 * j[Z] +
                    (J[Z] - ot[Z]) * mt +
                    (2 * ot[Z] - 5 * j[Z] + 4 * J[Z] - bt[Z]) * mt * mt +
                    (3 * j[Z] - ot[Z] - 3 * J[Z] + bt[Z]) * mt * mt * mt),
              ),
            );
          }
        }
      }
      F.push([A.x, A.y]);
      const I = [0];
      for (let P = 1; P < F.length; P++)
        I.push(
          I[P - 1] + Math.hypot(F[P][0] - F[P - 1][0], F[P][1] - F[P - 1][1]),
        );
      const D = I[I.length - 1] || 1,
        lt = F.findIndex(([P]) => Y * (P + (0.5 - E) * $ - c) >= 0);
      return {
        pts: F,
        cum: I.map((P) => P / D),
        tuck: lt < 0 ? 1 : I[lt] / D,
        back: w ? [0, 0] : null,
      };
    });
    const L = dt;
    dt = 1;
    const R = [ge(n), ge(s)],
      [H, T] = [g.phone.seat[2], g.phone.seat[3]];
    (Dt.forEach((x, v) => {
      if (!x) return;
      const [f, A] = U[v].it.fly,
        Y = Mt[v],
        $ = Wt(v, Y),
        et = (m) => {
          let z = 0.15,
            k = 1;
          for (let W = 0; W < 28; W++) {
            const F = (z + k) / 2;
            Oe(F) < m ? (z = F) : (k = F);
          }
          return f + ((z + k) / 2) * (A - f);
        },
        E = (m) => {
          const z = x.cum[m];
          return vt(v, {
            x: x.pts[m][0],
            y: x.pts[m][1],
            r: M(Y.r, $.r, z),
            s: M(Y.s, $.s, z),
          });
        },
        i = (m, z) => {
          const k = E(m),
            W = et(x.cum[m]);
          for (let I = 0; I < U.length; I++) {
            if (I === v) continue;
            const D = we(I, W);
            if (
              !D.hide &&
              (z || D.z === b.air || D.z === b.fly) &&
              $t(k, vt(I, D), z ? Ct : 6)
            )
              return !1;
          }
          const F = Yt(H, T, tt.r, tt.s);
          return !$t(
            k,
            { x0: tt.x - F.x, y0: tt.y - F.y, x1: tt.x + F.x, y1: tt.y + F.y },
            z ? Ct : 6,
          );
        },
        w = (m) => {
          const z = E(m);
          if (R.some((k) => $t(z, k, 14))) return !1;
          for (let k = z.x0 - 8; k <= z.x1 + 8; k += 4)
            if (fe(k) > z.y0 - 10 || ee(k) < z.y1 + 10) return !1;
          return i(m, !1);
        },
        p = x.cum.findIndex((m) => m >= x.tuck),
        B = x.cum
          .map((m, z) => z)
          .sort((m, z) => Math.abs(m - p) - Math.abs(z - p));
      for (const m of B)
        if (w(m)) {
          x.tuck = Math.max(x.cum[m], 1e-4);
          break;
        }
      if (x.back) {
        const m = x.cum.findIndex((F, I) => r(E(I)));
        let z = Math.max(0, m - 1);
        for (; z > 0 && !i(z, !0);) z--;
        let k = m;
        for (; k < x.cum.length && (r(E(k)) || !i(k, !0));) k++;
        const W = x.pts.reduce((F, I, D) => (I[1] < x.pts[F][1] ? D : F), 0);
        x.back = [Math.max(x.cum[z], 1e-4), x.cum[Math.min(k, W)]];
      }
    }),
      (dt = L));
  }
  function Ze(t, e) {
    const { pts: o, cum: n } = t;
    if (e <= 0) {
      const l = n[1] || 1;
      return [0, 1].map((y) => o[0][y] + (e / l) * (o[1][y] - o[0][y]));
    }
    if (e >= 1) return o[o.length - 1];
    let s = 1;
    for (; n[s] < e;) s++;
    const c = (e - n[s - 1]) / (n[s] - n[s - 1] || 1);
    return [0, 1].map((l) => M(o[s - 1][l], o[s][l], c));
  }
  function Ve(t, e, o) {
    const { it: n } = U[t],
      { h: s } = Q[t],
      [c, l, y] = Ut[t];
    switch (n.zone) {
      case "zip": {
        if (e >= 1) return { ...o, hide: !0 };
        const r = Q[t].w,
          u = c - r / 2,
          L = 8;
        let R = -1 / 0;
        for (let f = u; f <= u + r; f += 4) R = Math.max(R, oe(f));
        const H = o.y + _t(e) * (Math.max(R, oe(u + r)) + 2 - (o.y - s / 2)),
          T = H - s / 2,
          v = [
            u - L,
            ...g.zip.gapBottom
              .map(([f]) => f)
              .filter((f) => f > u - L && f < u + r + L),
            u + r + L,
          ].map((f) => [(f - u) / r, q((oe(f) - T) / s, -0.1, 1.2)]);
        return {
          x: c,
          y: H,
          r: y,
          s: 1,
          z: b.pouchIn,
          cut: v.some(([, f]) => f < 1.2) ? v : void 0,
        };
      }
      case "bar": {
        const [r, u] = g.holes[n.hole],
          L = Q[t].w,
          R = L / s,
          [H, T] = St[t],
          x = Math.min(1, qe / R),
          v = ue[n.id].hang ?? [[Jt, H, H, H]],
          f = (m) =>
            zt(
              v.map((z) => [z[0], z[m]]),
              Jt,
            ),
          A = f(2),
          Y = f(3),
          $ = r + He + (H - Y) * L * x,
          et = (m) => q((u - (m - T * s)) / s);
        if (e < 0.35) {
          const m = It(e / 0.35);
          return {
            x: M(o.x, r, m),
            y: o.y,
            r: M(o.r, 0, m),
            s: 1,
            sx: M(1, x, m),
            z: b.earring,
            shade: 1 - m,
          };
        }
        const E = u - Jt * s + T * s;
        if (e < 0.65) {
          const m = It((e - 0.35) / 0.3),
            z = M(o.y, E, m);
          return {
            x: M(r, $, m),
            y: z,
            r: 0,
            s: 1,
            sx: x,
            z: b.earring,
            clip: et(z),
            fadeL: A * m,
            fade: me * m,
            shade: 0,
          };
        }
        const i = qt((e - 0.65) / 0.35, 5),
          w = (i * Math.PI) / 180,
          p = $ - r,
          B = E - u;
        return {
          x: r + p * Math.cos(w) - B * Math.sin(w),
          y: u + p * Math.sin(w) + B * Math.cos(w),
          r: i,
          s: 1,
          sx: x,
          z: b.earring,
          clip: et(E),
          fadeL: A,
          fade: me,
          shade: 0,
        };
      }
      case "loopL":
      case "loopR": {
        const r = n.zone === "loopL" ? 1 : -1;
        if (e < 0.3) {
          const u = pt(e / 0.3);
          return {
            x: M(o.x, c, u),
            y: M(o.y, l, u) + 10 * st(u),
            r: M(o.r, 0, u),
            s: 1,
            sy: 1 + 0.06 * st(u),
            z: b.loopItem,
          };
        }
        return {
          x: c,
          y: l,
          r: -r * Math.abs(qt((e - 0.3) / 0.7, 7, 1.25)),
          s: 1,
          z: b.loopItem,
        };
      }
      default: {
        const r = _t(Math.min(1, e / 0.8));
        return {
          x: M(o.x, c, pt(Math.min(1, e / 0.8))),
          y: M(o.y, be[t], r) + qt((e - 0.8) / 0.2, -6),
          r: M(o.r, y, pt(Math.min(1, e / 0.8))),
          s: M(o.s, 1, r),
          sy: M(1, n.depth ?? 1, r),
          z: b.main,
        };
      }
    }
  }
  function re(t, e) {
    const o = Mt[t],
      n = Wt(t, o),
      s = Dt[t];
    if (s) {
      const [L, R] = Ze(s, e);
      return {
        x: L,
        y: R,
        r: M(o.r, n.r, q(e)),
        s: M(o.s, n.s, q(e)),
        z: b.fly,
      };
    }
    const c = Math.hypot(n.x - o.x, n.y - o.y),
      l = Math.min(160, 0.22 * c);
    let y = (o.x + n.x) / 2,
      r = Math.min(o.y, n.y) - l;
    o.y > -120 &&
      Math.abs(o.x) < 470 &&
      (y = Math.sign(o.x || n.x || 1) * (sw[t] ?? 520));
    const u = 1 - e;
    return {
      x: u * u * o.x + 2 * u * e * y + e * e * n.x,
      y: u * u * o.y + 2 * u * e * r + e * e * n.y,
      r: M(o.r, n.r, e),
      s: M(o.s, n.s, e),
      z: b.fly,
    };
  }
  function Je() {
    ze = U.map((t, e) => {
      const o = vt(e, re(e, 0)),
        n = Mt.map((s, c) => vt(c, { ...s })).filter(
          (s, c) => c > e && $t(o, s, -20),
        );
      for (let s = 0; s <= 1; s += 0.01)
        if (!n.some((c) => $t(vt(e, re(e, s)), c, Ct))) return s;
      return 1;
    });
  }
  function we(t, e) {
    const { it: o } = U[t],
      n = Mt[t],
      [s, c] = ye(t);
    if (e <= s) return { ...n, z: b.air };
    if (e < c) {
      const l = Oe(nt(e, [s, c])),
        y = Dt[t],
        r =
          y && l >= y.tuck
            ? b.loopFly
            : y?.back && l >= y.back[0] && l < y.back[1]
              ? b.behind
              : l < (ze[t] ?? 0)
                ? b.air
                : b.fly;
      return { ...re(t, l), z: r };
    }
    return Ve(t, q((e - c) / Ue(o.zone)), Wt(t, n));
  }
  const Qe = () => ({
      open: Qt(O.unpack.zipPouch.open, O.zipPouch.open),
      close: Qt(O.unpack.zipPouch.close, O.zipPouch.close),
    }),
    ie = (t, e) =>
      t < e.close[0] ? It(nt(t, e.open)) : 1 - It(nt(t, e.close));
  function Pt(t) {
    const e = nt(t, O.mainZip),
      o = e < 0.5,
      n = o ? pt(Math.min(1, e / 0.3)) * (1 - pt(q((e - 0.3) / 0.2))) : 0,
      s = o ? -26 * pt(q((e - 0.3) / 0.2)) : 0;
    let c = 0;
    (U.forEach(({ it: i }, w) => {
      i.zone === "main" &&
        (c = Math.max(
          c,
          st(q((t - ye(w)[1] - 0.6 * O.settle.main) / (0.5 * O.settle.main))),
        ));
    }),
      [
        d.openBack,
        d.openFront,
        d.zipPanel,
        d.tabL,
        d.tabR,
        d.rim,
        d.zipUnder,
        d.zipOver,
        d.slider,
        d.pull,
      ].forEach((i) => ut(i, o)));
    const l = 1 - 0.035 * n - 0.015 * c,
      y = 1 + 0.03 * n + 0.012 * c;
    if (o) {
      const i = (Rt, mt, Z) => {
        const [oo, no] = te(mt);
        ct(Rt, oo * y, no * l + s, 0, y, l, Z);
      };
      (i(d.openBack, G.openBack.box, b.openBack),
        i(d.zipUnder, g.zip.under.box, b.zipUnder),
        i(d.zipOver, g.zip.over.box, b.zipOver),
        i(d.zipPanel, G.zipPanel.box, b.zipPanel),
        i(d.tabL, G.tabL.box, b.tab),
        i(d.tabR, G.tabR.box, b.tab),
        i(d.rim, G.rim.box, b.rim),
        i(d.openFront, G.openFront.box, b.plate));
      const w = Qe(),
        p = ie(t, w) * (Be - 1),
        B = Math.round(p),
        m = g.zip.states[Math.floor(p)],
        z = g.zip.states[Math.min(Be - 1, Math.ceil(p))],
        k = p - Math.floor(p),
        W = M(m.dx, z.dx, k),
        F = M(m.dy, z.dy, k),
        I = d.zipUnder._h;
      ((d.zipUnderImg.style.transform = `translate3d(0, ${(-B * I).toFixed(2)}px, 0)`),
        (d.zipOverImg.style.transform = d.zipUnderImg.style.transform));
      const D = 0.002,
        lt = (ie(t + D, w) - ie(t - D, w)) / (2 * D),
        P = w.open[1] - w.open[0],
        C = w.close[1] - w.close[0],
        X = -3 * st(nt(t, [w.open[0], w.open[0] + 0.15 * P])),
        ot =
          lt >= 0
            ? 16 * lt * (P / 3) + qt(nt(t, [w.open[1], w.open[1] + 0.03]), -6)
            : 12 * lt * (C / 3) + qt(nt(t, [w.close[1], w.close[1] + 0.03]), 8),
        j = g.zip.slider.box,
        J = g.zip.pull.box,
        bt = g.zip.pull.pivot;
      (ct(
        d.slider,
        (j[0] + j[2] / 2 + W + X) * y,
        (j[1] + j[3] / 2 + F) * l + s,
        0,
        y,
        l,
        b.slider,
      ),
        ct(
          d.pull,
          (J[0] + bt[0] + W + X) * y,
          (J[1] + bt[1] + F) * l + s,
          ot,
          y,
          l,
          b.pull,
          bt[0] / J[2],
          bt[1] / J[3],
        ));
    }
    const r = nt(t, O.flip),
      u = r >= 0.45,
      L =
        r <= 0
          ? 0
          : r < 0.2
            ? -46 * pt(r / 0.2)
            : r < 0.45
              ? -46
              : r < 0.7
                ? M(-46, -22, It((r - 0.45) / 0.25))
                : r < 0.85
                  ? -22 * (1 - _t((r - 0.7) / 0.15))
                  : 0,
      R = r < 0.45 ? -4 * st(r / 0.45) : 2 * st((r - 0.45) / 0.4),
      H =
        r < 0.2
          ? 1
          : r < 0.45
            ? 1 - _t((r - 0.2) / 0.25)
            : r < 0.7
              ? pt((r - 0.45) / 0.25)
              : 1,
      T = 1 - 0.03 * st((r - 0.85) / 0.15),
      x = !o && !u;
    if ((ut(d.closed, x), x)) {
      const [i, w] = te(g.closed.box),
        p = -26 * (1 - _t(q((e - 0.5) / 0.3))),
        B = 1 - 0.03 * st(q((e - 0.8) / 0.2)),
        m = ((1 - B) * g.closed.box[3]) / 2;
      ct(
        d.closed,
        i,
        w + p + L + m,
        R,
        Math.max(0.001, H) * (B < 1 ? 1 + (1 - B) : 1),
        B,
        b.plate,
      );
    }
    if ((ut(d.back, u), ut(d.pocketFront, u), u)) {
      const [i, w] = te(g.back.box),
        p = w + L + ((1 - T) * g.back.box[3]) / 2,
        B = Math.max(0.001, H) * (T < 1 ? 1 + (1 - T) : 1);
      (ct(d.back, i, p, R, B, T, b.plate),
        ct(d.pocketFront, i, p, R, B, T, b.pocketFront));
    }
    const v = Math.max(-s, -L, o ? 0 : 26 * (1 - _t(q((e - 0.5) / 0.3)))) / 46;
    (ut(d.ground, !0),
      ct(
        d.ground,
        0,
        8,
        0,
        (o ? 1.02 : 1) * (1 - 0.12 * v),
        1 - 0.1 * v,
        b.ground,
      ),
      (d.ground.style.opacity = (1 - 0.35 * v).toFixed(3)),
      U.forEach(({ node: i }, w) => {
        const p = we(w, t),
          B = o && !p.hide;
        if ((ut(i, B), !B)) return;
        const m =
            p.z !== b.air &&
            p.z !== b.fly &&
            p.z !== b.loopFly &&
            p.z !== b.behind,
          z = m ? y : 1,
          k = m ? l : 1,
          [W, F] = St[w];
        ct(
          i,
          p.x * z,
          p.y * k + (m ? s : 0),
          p.r,
          p.s * (p.sx ?? 1) * z,
          p.s * (p.sy ?? 1) * k,
          p.z,
          W,
          F,
        );
        const I = i,
          D = p.clip
            ? `inset(${(p.clip * 100).toFixed(2)}% 0 0 0)`
            : p.cut
              ? `polygon(${[[p.cut[0][0], -0.1], [p.cut[p.cut.length - 1][0], -0.1], ...[...p.cut].reverse()].map(([X, ot]) => `${(X * 100).toFixed(2)}% ${(ot * 100).toFixed(2)}%`).join(", ")})`
              : "";
        I._clip !== D && ((i.style.clipPath = D), (I._clip = D));
        const lt = p.fadeL ? (p.fade ?? 0) / 2 : 0,
          P = p.fadeL
            ? `linear-gradient(to right, transparent ${((p.fadeL - lt) * 100).toFixed(2)}%, #000 ${((p.fadeL + lt) * 100).toFixed(2)}%)`
            : "";
        I._mask !== P &&
          ((i.style.maskImage = P),
          i.style.setProperty("-webkit-mask-image", P),
          (I._mask = P));
        const C = p.shade === void 0 ? "" : p.shade.toFixed(3);
        (I._shade !== C &&
          (i.style.setProperty("--shade", C),
          i.classList.toggle("is-shaded", C !== ""),
          (I._shade = C)),
          i.classList.toggle("is-in", m));
      }));
    const f = g.phone.seat,
      A = { x: f[0] + f[2] / 2, y: f[1] + f[3] / 2 },
      Y = {
        x: Math.max(g.pocketEdgeX + f[2] / 2 + 14, A.x + 40),
        y: A.y,
        r: 1.5,
      };
    let $;
    const et = nt(t, O.phoneWalk),
      E = nt(t, O.phoneTuck);
    if (E > 0) {
      const i = pt(E);
      $ = {
        x: M(Y.x, A.x, i) - 8 * st(q((E - 0.6) / 0.4)),
        y: M(Y.y, A.y, i),
        r: M(Y.r, 0, i),
        s: 1,
        z: b.pocket,
      };
    } else {
      const i = It(et);
      $ = {
        x: M(tt.x, Y.x, i),
        y: M(tt.y, Y.y, i) - st(i) * 80,
        r: M(tt.r, Y.r, i),
        s: M(tt.s, 1, i),
        z: b.air,
      };
    }
    if (
      (ut(d.phone, !0),
      ct(d.phone, $.x, $.y, $.r, $.s, $.s, $.z),
      d.phone.classList.toggle("is-in", $.z === b.pocket),
      at && kt < 0)
    ) {
      const i = ne * io(nt(t, O.moveUp));
      ((at.style.transform = i
        ? `translate3d(0, ${(-i).toFixed(2)}px, 0)`
        : ""),
        (Zt.style.transform = i ? `translate3d(0, ${i.toFixed(2)}px, 0)` : ""));
    }
    // Grow (theme addition, not in the prototype): once the zip is shut the
    // bag comes toward you. The stage scales about the bag's spot through
    // the flip and the phone tuck, then holds, so the closed bag fills the
    // frame instead of floating in it. Out at the pocket opening the phone
    // and the bag together run wider than a phone screen, so there the zoom
    // gives way and the stage pans to keep both in shot until the tuck.
    {
      let z = 1 + (growTo - 1) * It(nt(t, [O.mainZip[1], O.phoneTuck[1]]));
      const pw = Yt(f[2], f[3], $.r, $.s).x,
        bl = Math.min(g.back.box[0], $.x - pw),
        br = Math.max(g.back.box[0] + g.back.box[2], $.x + pw),
        room = Tt - Math.max(10, 0.03 * ht);
      z = Math.min(z, (2 * room) / ((br - bl) * V));
      const px = Math.max(Math.min(0, room - br * V * z), -room - bl * V * z);
      _.style.transform =
        Math.abs(z - 1) > 0.001 || Math.abs(px) > 0.05
          ? `translate3d(${px.toFixed(2)}px, 0, 0) scale(${z.toFixed(4)})`
          : "";
    }
    (Xt(Ht, t < O.questionOut), Xt(gt, t >= O.answerIn));
  }
  function Xt(t, e) {
    t._on !== e && ((t._on = e), t.classList.toggle("is-on", e));
  }
  let yt = 0,
    N = 0,
    Bt = 0,
    jt = 0,
    kt = -1,
    ft = -1,
    Ot = !1;
  function ae() {
    return (
      document.documentElement.clientHeight - a.getBoundingClientRect().top
    );
  }
  function ce() {
    const t = document.documentElement.clientHeight,
      e = ae(),
      { start: o, stuck: n } = h.scroll[K];
    return e < t
      ? h.holdAt > 0
        ? h.holdAt * q((e - o * t) / (t - o * t))
        : 0
      : h.holdAt + (1 - h.holdAt) * q((e - t) / n);
  }
  function Me(t) {
    if (((Bt = 0), Ot || ft >= 0 || kt >= 0)) return;
    yt = ce();
    const e = jt ? Math.min(64, t - jt) : 16;
    jt = t;
    const o = h.smoothMs > 0 ? 1 - Math.exp(-e / h.smoothMs) : 1,
      n = Math.abs(yt - N) < 1e-4 ? yt : N + (yt - N) * o;
    (n !== N &&
      ((dt = q(dt + ((n - N) * h.scroll[K].stuck) / (1 - h.holdAt) / We)),
      (N = n),
      Pt(N)),
      N !== yt ? (Bt = requestAnimationFrame(Me)) : (jt = 0));
  }
  const ve = () => {
      Bt || (Bt = requestAnimationFrame(Me));
    },
    Pe = location.search.includes("plotNoAssist"),
    to = 400,
    ke = 140;
  let rt = 0,
    Gt = 0,
    it = 0,
    Ft = 0,
    le = 0,
    pe = 0,
    Lt = window.scrollY,
    At = 0;
  function Kt(t) {
    const e = document.documentElement.clientHeight,
      { start: o, stuck: n } = h.scroll[K],
      s = a.getBoundingClientRect().top + window.scrollY,
      c =
        t < h.holdAt
          ? o * e + (t / h.holdAt) * (e - o * e)
          : e + ((t - h.holdAt) / (1 - h.holdAt)) * n;
    return s + c - e;
  }
  function Fe(t) {
    rt ||
      ((Gt = t),
      (it = window.scrollY),
      (le = performance.now()),
      (Ft = 0),
      (rt = requestAnimationFrame(Ae)));
  }
  function Le() {
    (rt && cancelAnimationFrame(rt), (rt = 0), (Lt = window.scrollY));
  }
  function Ae(t) {
    if (((rt = 0), Ot)) return;
    const e = window.scrollY;
    if (Math.abs(e - it) > 2) {
      ((At = Math.sign(e - it)), (Lt = e), de());
      return;
    }
    const o = Math.min(50, t - le);
    le = t;
    const n = Kt(h.assist.from),
      s = Kt(h.assist.to),
      c = Gt > 0 ? s : n,
      l = (s - n) / h.assist.ms,
      y = Math.abs(c - it),
      r = l * Math.sqrt(Math.min(1, y / ke));
    ((Ft += (Math.min(l, r) - Ft) * (1 - Math.exp(-o / to))),
      y < ke && (Ft = Math.min(Ft, Math.max(r, 0.004))),
      (it += Gt * Ft * o));
    const u = Gt > 0 ? it >= c - 0.5 : it <= c + 0.5;
    (u && (it = c),
      window.scrollTo({ top: it, behavior: "instant" }),
      (Lt = it),
      u ? (At = 0) : (rt = requestAnimationFrame(Ae)));
  }
  function Ee() {
    if ((ve(), rt || Pe || !h.assist.on || kt >= 0)) return;
    const t = window.scrollY;
    (t !== Lt && (At = Math.sign(t - Lt)), (Lt = t), de());
  }
  function de() {
    (clearTimeout(pe),
      !(Pe || !h.assist.on) &&
        (pe = window.setTimeout(() => {
          if (rt || Ot || kt >= 0) return;
          const t = Kt(h.assist.from),
            e = Kt(h.assist.to),
            o = window.scrollY;
          o > t + 1 && o < e - 1
            ? Fe(At < 0 ? -1 : 1)
            : o >= t - h.assist.lead && o <= t + 1 && At > 0 && Fe(1);
        }, h.assist.wait)));
  }
  const Nt = (t) => {
      rt && (Le(), t && (At = t), de());
    },
    Ie = (t) => Nt(Math.sign(t.deltaY)),
    _e = () => Nt(0),
    Se = (t) => {
      const e = t.key;
      e === "ArrowDown" ||
      e === "PageDown" ||
      e === "End" ||
      (e === " " && !t.shiftKey)
        ? Nt(1)
        : (e === "ArrowUp" ||
            e === "PageUp" ||
            e === "Home" ||
            (e === " " && t.shiftKey)) &&
          Nt(-1);
    },
    he = window.matchMedia("(prefers-reduced-motion: reduce)"),
    eo = () => window.innerHeight < 480 || window.innerWidth < 300;
  let lastW = 0;
  function Et() {
    const t = he.matches || eo(),
      // Theme addition: a width change (rotation, window resize) reflows the
      // page above and resizes the runway, which would land the viewer on a
      // different moment. Width only, so a phone toolbar sliding away never
      // moves the page.
      keep =
        !t &&
        kt < 0 &&
        ft < 0 &&
        lastW &&
        lastW !== window.innerWidth &&
        N > h.holdAt &&
        N < 1
          ? N
          : -1;
    lastW = window.innerWidth;
    (a.classList.toggle("is-static", t), a.classList.toggle("is-live", !t));
    const e = !t && at ? at : Zt;
    (t && at && ((at.style.transform = ""), (Zt.style.transform = "")),
      gt.parentElement !== e && e.appendChild(gt),
      (kt = t ? O.packed : -1),
      !t && ft < 0 && (N = yt = ce()),
      Ke(),
      t ? (Pt(kt), ut(d.phone, !1), Xt(Ht, !1), Xt(gt, !0)) : ve());
    keep >= 0 &&
      (window.scrollTo({ top: Kt(keep), behavior: "instant" }),
      (N = yt = keep),
      Pt(N));
  }
  let Te = "";
  const $e = new ResizeObserver(() => {
    const t = `${_.clientWidth}x${_.clientHeight}`;
    t !== Te && ((Te = t), Et(), ft >= 0 && Pt(ft));
  });
  if (
    ($e.observe(_),
    window.addEventListener("scroll", Ee, { passive: !0 }),
    window.addEventListener("wheel", Ie, { passive: !0 }),
    window.addEventListener("touchstart", _e, { passive: !0 }),
    window.addEventListener("keydown", Se),
    window.addEventListener("resize", Et),
    he.addEventListener("change", Et),
    Vt.push(
      () => {
        Ot = !0;
      },
      () => $e.disconnect(),
      () => window.removeEventListener("scroll", Ee),
      () => window.removeEventListener("wheel", Ie),
      () => window.removeEventListener("touchstart", _e),
      () => window.removeEventListener("keydown", Se),
      () => clearTimeout(pe),
      () => Le(),
      () => window.removeEventListener("resize", Et),
      () => he.removeEventListener("change", Et),
      () => cancelAnimationFrame(Bt),
    ),
    _.querySelectorAll("img[data-l]").forEach((t) => {
      t.decode().catch(() => {});
    }),
    Et(),
    ((() => {
      try {
        return !1;
      } catch {
        return !1;
      }
    })() ||
      location.search.includes("plotDebug")) &&
      ((window.__plot = {
        seek(t, e) {
          (e && (dt = e < 0 ? 0 : 1), (ft = q(t)), Pt(ft));
        },
        release() {
          ((ft = -1), (N = yt = ce()), Pt(N));
        },
        state: () => ({ travel: ae(), story: N, mode: K, scroll: h.scroll[K] }),
      }),
      location.search.includes("plotDebug")))
  ) {
    const t = document.createElement("div");
    ((t.style.cssText =
      "position:fixed;left:8px;bottom:8px;z-index:9999;font:12px/1.3 monospace;background:#000c;color:#fff;padding:4px 7px;border-radius:4px;pointer-events:none"),
      document.body.appendChild(t));
    const e = () => {
        const n = h.scroll[K];
        t.textContent = `travel ${Math.round(ae())}px  story ${N.toFixed(3)}  start ${n.start} stuck ${n.stuck}px rise ${Math.round(ne)}px`;
      },
      o = () => {
        Ot || (e(), requestAnimationFrame(o));
      };
    (o(), Vt.push(() => t.remove()));
  }
  return () => Vt.forEach((t) => t());
}
// Theme wiring: one instance per [data-plot], re-armed when the theme editor
// reloads the section, torn down when it unloads.
const teardowns = new WeakMap();
function initAll() {
  document.querySelectorAll("[data-plot]:not([data-plot-init])").forEach((el) => {
    el.setAttribute("data-plot-init", "");
    teardowns.set(el, ao(el, ro));
  });
}
initAll();
document.addEventListener("shopify:section:load", initAll);
document.addEventListener("shopify:section:unload", (e) => {
  e.target.querySelectorAll("[data-plot]").forEach((el) => {
    const t = teardowns.get(el);
    if (t) t();
  });
});
})();
